import { useEffect, useState, useMemo, useRef } from 'react';
import { apiHolder as api } from 'api';
import { getValidStoreWidth } from '@web-common/utils/utils';
import useWindowSize from '@web-common/hooks/windowResize';
import useState2RM from './useState2ReduxMock';
import { useAppSelector } from '@web-common/state/createStore';
const storeApi = api.api.getDataStoreApi();
const STORE_MAIL_FOLDER_WIDTH = 'STORE_MAIL_FOLDER_WIDTH';
const STORE_MAIL_LIST_WIDTH = 'STORE_MAIL_LIST_WIDTH';
export const STORE_CUSTOMER_LIST_HEIGHT = 'STORE_MAIL_LIST_HEIGHT';
export const DEFAULT_LIST_WIDTH = 310;
export const DEFAULT_LIST_MIN_WIDTH = 260;
export const DEFAULT_FOLDER_WIDTH = 220;
export const DEFAULT_FOLDER_MIN_WIDTH = 200;
export const DEFAULT_CUSTOMER_WIDTH = 340;
export const DEFAULT_READ_MAIL_MIN_WIDTH = 432;
export const folderWidthStorePut = (width) => {
    storeApi.putSync(STORE_MAIL_FOLDER_WIDTH, width, { prefix: 'layout_storage_cache', storeMethod: 'localStorage' });
};
export const mailListWidthStorePut = (width) => {
    storeApi.putSync(STORE_MAIL_LIST_WIDTH, width, { prefix: 'layout_storage_cache', storeMethod: 'localStorage' });
};
const useAppScale = () => {
    const mailListResizeProcessing = useAppSelector(state => state.mailReducer.mailListResizeProcessing);
    const currentTabType = useAppSelector(state => state.mailTabReducer.showMailSidebar);
    const [configMailLayout] = useState2RM('configMailLayout', 'doUpdateConfigMailLayout');
    const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
    const [folderListWidth, setFolderListWidth] = useState(220);
    const [mailListWidth, setMailListWidth] = useState(310);
    const [appWidth, setAppWidth] = useState(0);
    const [folderListSettingWidth, setFolderListSettingWidth] = useState(220);
    const [mailListSettingWidth, setMailListSettingWidth] = useState(310);
    const [mailListMaxConstraints, setMailListMaxConstraints] = useState(500);
    const [folderListMaxConstraints, setfolderListMaxConstraints] = useState(500);
    const prevAppWidth = useRef(appWidth);
    const offset = useWindowSize(false);
    useEffect(() => {
        if (mailListResizeProcessing) {
            return;
        }
        setRecordWidth();
    }, [mailListResizeProcessing, isLeftRight]);
    useEffect(() => {
        if (currentTabType) {
            return;
        }
        setRecordWidth();
    }, [isLeftRight, currentTabType]);
    useEffect(() => {
        if (appWidth <= 0 || !appWidth) {
            return;
        }
        const readMailMinWidth = currentTabType ? DEFAULT_CUSTOMER_WIDTH + DEFAULT_READ_MAIL_MIN_WIDTH : DEFAULT_READ_MAIL_MIN_WIDTH;
        const maxWidth = appWidth - (readMailMinWidth + 5) - folderListWidth - mailListWidth - 68;
        if (maxWidth > 0) {
            setMailListMaxConstraints(mailListWidth + maxWidth > 500 ? 500 : mailListWidth + maxWidth);
            setfolderListMaxConstraints(folderListWidth + maxWidth > 500 ? 500 : folderListWidth + maxWidth);
        }
        else {
            const maxFolder = folderListWidth > DEFAULT_FOLDER_MIN_WIDTH ? DEFAULT_FOLDER_MIN_WIDTH - folderListWidth : 0;
            const maxMail = mailListWidth > DEFAULT_LIST_MIN_WIDTH ? DEFAULT_LIST_MIN_WIDTH - mailListWidth : 0;
            const { folderWidth, mailWidth } = lessenColumnWidthss(maxWidth, maxFolder, maxMail);
            setMailListMaxConstraints(mailWidth);
            setfolderListMaxConstraints(folderWidth);
        }
    }, [currentTabType, appWidth, folderListWidth, mailListWidth]);
    const setRecordWidth = () => {
        const storeFolderWidth = getValidStoreWidth(storeApi.getSync(STORE_MAIL_FOLDER_WIDTH, { prefix: 'layout_storage_cache', storeMethod: 'localStorage' }));
        if (storeFolderWidth > 0) {
            setFolderListSettingWidth(storeFolderWidth);
            setFolderListWidth(storeFolderWidth);
        }
        else {
            setFolderListSettingWidth(DEFAULT_FOLDER_WIDTH);
            setFolderListWidth(DEFAULT_FOLDER_WIDTH);
        }
        const storeListWidth = getValidStoreWidth(storeApi.getSync(STORE_MAIL_LIST_WIDTH, { prefix: 'layout_storage_cache', storeMethod: 'localStorage' }));
        if (storeListWidth > 0 && isLeftRight) {
            setMailListSettingWidth(storeListWidth);
            setMailListWidth(storeListWidth);
        }
        else {
            setMailListSettingWidth(storeListWidth);
            setMailListWidth(DEFAULT_LIST_WIDTH);
        }
    };
    const magnifyColumnWidth = (changeWidth, maxFolder, maxMail) => {
        let folderChangeWidth = 0;
        let mailChangeWidth = 0;
        if (Math.abs(maxFolder) - Math.abs(changeWidth) > 0) {
            folderChangeWidth = changeWidth;
            mailChangeWidth = 0;
        }
        else {
            folderChangeWidth = maxFolder;
            mailChangeWidth = Math.abs(maxMail + maxFolder) - Math.abs(changeWidth) > 0 ? changeWidth - maxFolder : maxMail;
        }
        const folderWidth = folderListWidth + folderChangeWidth;
        const mailWidth = mailListWidth + mailChangeWidth;
        setFolderListWidth(folderWidth);
        setMailListWidth(mailWidth);
        return {
            folderWidth,
            mailWidth,
        };
    };
    const lessenColumnWidthss = (changeWidth, maxFolder, maxMail) => {
        let folderChangeWidth = 0;
        let mailChangeWidth = 0;
        const readMailMinWidth = currentTabType ? DEFAULT_CUSTOMER_WIDTH + DEFAULT_READ_MAIL_MIN_WIDTH : DEFAULT_READ_MAIL_MIN_WIDTH;
        const maxWidth = appWidth - (readMailMinWidth + 5) - folderListWidth - mailListWidth - 68;
        if (maxWidth > 0) {
            return {
                folderWidth: folderListWidth,
                mailWidth: mailListWidth,
            };
        }
        if (Math.abs(maxMail) - Math.abs(changeWidth) > 0) {
            folderChangeWidth = 0;
            mailChangeWidth = changeWidth;
        }
        else {
            mailChangeWidth = maxMail;
            folderChangeWidth = Math.abs(maxMail + maxFolder) - Math.abs(changeWidth) > 0 ? changeWidth - maxMail : maxFolder;
        }
        const folderWidth = folderListWidth + folderChangeWidth;
        const mailWidth = mailListWidth + mailChangeWidth;
        setFolderListWidth(folderWidth);
        setMailListWidth(mailWidth);
        return {
            folderWidth,
            mailWidth,
        };
    };
    useEffect(() => {
        if (offset === null || offset === void 0 ? void 0 : offset.width) {
            const changeWidth = (offset === null || offset === void 0 ? void 0 : offset.width) - prevAppWidth.current;
            let maxFolder;
            let maxMail;
            if (changeWidth > 0) {
                maxFolder = folderListWidth < folderListSettingWidth ? folderListSettingWidth - folderListWidth : 0;
                maxMail = mailListWidth < mailListSettingWidth ? mailListSettingWidth - mailListWidth : 0;
                magnifyColumnWidth(changeWidth, maxFolder, maxMail);
            }
            else {
                maxFolder = folderListWidth > DEFAULT_FOLDER_MIN_WIDTH ? DEFAULT_FOLDER_MIN_WIDTH - folderListWidth : 0;
                maxMail = mailListWidth > DEFAULT_LIST_MIN_WIDTH ? DEFAULT_LIST_MIN_WIDTH - mailListWidth : 0;
                lessenColumnWidthss(changeWidth, maxFolder, maxMail);
            }
            setAppWidth(offset.width);
            prevAppWidth.current = offset.width;
        }
    }, [offset === null || offset === void 0 ? void 0 : offset.width]);
    return {
        folderListWidth,
        mailListWidth,
        mailListMaxConstraints,
        folderListMaxConstraints,
        appWidth,
    };
};
export default useAppScale;
